import { createContext } from "react";

export const ArticulosContext = createContext()
export const ArticulosFormContext = createContext()
export const ArticulosReportContext = createContext()